var map = {
	"./404.webp": "./src/assets/images/404.webp",
	"./alert.webp": "./src/assets/images/alert.webp",
	"./arrow-square-up-right.png": "./src/assets/images/arrow-square-up-right.png",
	"./banker-tooltip.webp": "./src/assets/images/banker-tooltip.webp",
	"./bet-btn-tx.webp": "./src/assets/images/bet-btn-tx.webp",
	"./bet_bg.png": "./src/assets/images/bet_bg.png",
	"./bg_major_ticket.webp": "./src/assets/images/bg_major_ticket.webp",
	"./bg_mini_ticket.webp": "./src/assets/images/bg_mini_ticket.webp",
	"./bg_minor_ticket.webp": "./src/assets/images/bg_minor_ticket.webp",
	"./blue.webp": "./src/assets/images/blue.webp",
	"./burger_bg.png": "./src/assets/images/burger_bg.png",
	"./calendar.webp": "./src/assets/images/calendar.webp",
	"./candle_bg.png": "./src/assets/images/candle_bg.png",
	"./cf_bg.png": "./src/assets/images/cf_bg.png",
	"./close.webp": "./src/assets/images/close.webp",
	"./cockfight-menu-active-bg.svg": "./src/assets/images/cockfight-menu-active-bg.svg",
	"./cockfight-menu-active-icon.svg": "./src/assets/images/cockfight-menu-active-icon.svg",
	"./cockfight-menu-bg.svg": "./src/assets/images/cockfight-menu-bg.svg",
	"./cockfight-menu-icon.svg": "./src/assets/images/cockfight-menu-icon.svg",
	"./coin.png": "./src/assets/images/coin.png",
	"./coin.webp": "./src/assets/images/coin.webp",
	"./coins.png": "./src/assets/images/coins.png",
	"./crown.png": "./src/assets/images/crown.png",
	"./current_jackpot_bg.png": "./src/assets/images/current_jackpot_bg.png",
	"./dice-icon-active.svg": "./src/assets/images/dice-icon-active.svg",
	"./dice-icon-default.svg": "./src/assets/images/dice-icon-default.svg",
	"./dice-icon-outline.svg": "./src/assets/images/dice-icon-outline.svg",
	"./dice-menu-active.webp": "./src/assets/images/dice-menu-active.webp",
	"./dice-menu.webp": "./src/assets/images/dice-menu.webp",
	"./dice-tab-bg.svg": "./src/assets/images/dice-tab-bg.svg",
	"./draw-basewsoccerball.webp": "./src/assets/images/draw-basewsoccerball.webp",
	"./ended.webp": "./src/assets/images/ended.webp",
	"./fire-ic.gif": "./src/assets/images/fire-ic.gif",
	"./flags/asean.webp": "./src/assets/images/flags/asean.webp",
	"./flags/co.webp": "./src/assets/images/flags/co.webp",
	"./flags/dr.webp": "./src/assets/images/flags/dr.webp",
	"./flags/id.webp": "./src/assets/images/flags/id.webp",
	"./flags/kh.webp": "./src/assets/images/flags/kh.webp",
	"./flags/mx.webp": "./src/assets/images/flags/mx.webp",
	"./flags/pe.webp": "./src/assets/images/flags/pe.webp",
	"./flags/ph.webp": "./src/assets/images/flags/ph.webp",
	"./flags/th.webp": "./src/assets/images/flags/th.webp",
	"./flags/vn.webp": "./src/assets/images/flags/vn.webp",
	"./flags/zh.webp": "./src/assets/images/flags/zh.webp",
	"./footer-bar-bg.svg": "./src/assets/images/footer-bar-bg.svg",
	"./game-help/10min.webp": "./src/assets/images/game-help/10min.webp",
	"./game-help/betsection.webp": "./src/assets/images/game-help/betsection.webp",
	"./game-help/cambodia-bg-mobile.webp": "./src/assets/images/game-help/cambodia-bg-mobile.webp",
	"./game-help/cambodia-bg.webp": "./src/assets/images/game-help/cambodia-bg.webp",
	"./game-help/ccf-1.webp": "./src/assets/images/game-help/ccf-1.webp",
	"./game-help/ccf-2.webp": "./src/assets/images/game-help/ccf-2.webp",
	"./game-help/ccf-3.webp": "./src/assets/images/game-help/ccf-3.webp",
	"./game-help/ccf-4.webp": "./src/assets/images/game-help/ccf-4.webp",
	"./game-help/draw.webp": "./src/assets/images/game-help/draw.webp",
	"./game-help/en.webp": "./src/assets/images/game-help/en.webp",
	"./game-help/id.webp": "./src/assets/images/game-help/id.webp",
	"./game-help/jackpot/lucky-draw-instant-prize-custom.webp": "./src/assets/images/game-help/jackpot/lucky-draw-instant-prize-custom.webp",
	"./game-help/jackpot/lucky-draw-instant-prize.webp": "./src/assets/images/game-help/jackpot/lucky-draw-instant-prize.webp",
	"./game-help/jackpot/major.png": "./src/assets/images/game-help/jackpot/major.png",
	"./game-help/jackpot/mini.png": "./src/assets/images/game-help/jackpot/mini.png",
	"./game-help/jackpot/minor.png": "./src/assets/images/game-help/jackpot/minor.png",
	"./game-help/jackpot/physical/major-gold.webp": "./src/assets/images/game-help/jackpot/physical/major-gold.webp",
	"./game-help/jackpot/physical/major-prize.webp": "./src/assets/images/game-help/jackpot/physical/major-prize.webp",
	"./game-help/jackpot/physical/mini-gold.webp": "./src/assets/images/game-help/jackpot/physical/mini-gold.webp",
	"./game-help/jackpot/physical/mini-prize.webp": "./src/assets/images/game-help/jackpot/physical/mini-prize.webp",
	"./game-help/jackpot/physical/minor-gold.webp": "./src/assets/images/game-help/jackpot/physical/minor-gold.webp",
	"./game-help/jackpot/physical/minor-prize.webp": "./src/assets/images/game-help/jackpot/physical/minor-prize.webp",
	"./game-help/jackpot/progress-en.webp": "./src/assets/images/game-help/jackpot/progress-en.webp",
	"./game-help/ph-bg-mobile.webp": "./src/assets/images/game-help/ph-bg-mobile.webp",
	"./game-help/ph-bg.webp": "./src/assets/images/game-help/ph-bg.webp",
	"./game-help/table-bg-mobile.webp": "./src/assets/images/game-help/table-bg-mobile.webp",
	"./game-help/table-bg.webp": "./src/assets/images/game-help/table-bg.webp",
	"./game-help/tgg-1.webp": "./src/assets/images/game-help/tgg-1.webp",
	"./game-help/tgg-2.webp": "./src/assets/images/game-help/tgg-2.webp",
	"./game-help/tgg-3.webp": "./src/assets/images/game-help/tgg-3.webp",
	"./game-help/tgg-4.webp": "./src/assets/images/game-help/tgg-4.webp",
	"./game-help/th.webp": "./src/assets/images/game-help/th.webp",
	"./game-help/vn.webp": "./src/assets/images/game-help/vn.webp",
	"./gift-box.webp": "./src/assets/images/gift-box.webp",
	"./green.webp": "./src/assets/images/green.webp",
	"./help-icon.webp": "./src/assets/images/help-icon.webp",
	"./help.webp": "./src/assets/images/help.webp",
	"./history-detail.webp": "./src/assets/images/history-detail.webp",
	"./history-icon.webp": "./src/assets/images/history-icon.webp",
	"./history.webp": "./src/assets/images/history.webp",
	"./instant-prize.webp": "./src/assets/images/instant-prize.webp",
	"./jackpot-help-icon.webp": "./src/assets/images/jackpot-help-icon.webp",
	"./jackpot-help.svg": "./src/assets/images/jackpot-help.svg",
	"./jackpot-history.svg": "./src/assets/images/jackpot-history.svg",
	"./jackpot-instant-prize.svg": "./src/assets/images/jackpot-instant-prize.svg",
	"./jackpot-lucky-draw.svg": "./src/assets/images/jackpot-lucky-draw.svg",
	"./jackpot-physical-btn.webp": "./src/assets/images/jackpot-physical-btn.webp",
	"./jackpot.webp": "./src/assets/images/jackpot.webp",
	"./limits.webp": "./src/assets/images/limits.webp",
	"./lobby.webp": "./src/assets/images/lobby.webp",
	"./logos/default.webp": "./src/assets/images/logos/default.webp",
	"./logos/logo.jpg": "./src/assets/images/logos/logo.jpg",
	"./logos/p1.webp": "./src/assets/images/logos/p1.webp",
	"./logos/worldcup-logo.webp": "./src/assets/images/logos/worldcup-logo.webp",
	"./major-ticket-star.webp": "./src/assets/images/major-ticket-star.webp",
	"./major-ticket.webp": "./src/assets/images/major-ticket.webp",
	"./menu-bg.svg": "./src/assets/images/menu-bg.svg",
	"./mini-ticket.webp": "./src/assets/images/mini-ticket.webp",
	"./minor-ticket.webp": "./src/assets/images/minor-ticket.webp",
	"./notification-icon.webp": "./src/assets/images/notification-icon.webp",
	"./notification.webp": "./src/assets/images/notification.webp",
	"./out-of-money.png": "./src/assets/images/out-of-money.png",
	"./out-of-money.svg": "./src/assets/images/out-of-money.svg",
	"./past-flag.webp": "./src/assets/images/past-flag.webp",
	"./past_jackpot_bg.png": "./src/assets/images/past_jackpot_bg.png",
	"./payout-tai-banner.svg": "./src/assets/images/payout-tai-banner.svg",
	"./payout-xiu-banner.svg": "./src/assets/images/payout-xiu-banner.svg",
	"./play.png": "./src/assets/images/play.png",
	"./player-tooltip.webp": "./src/assets/images/player-tooltip.webp",
	"./prize.png": "./src/assets/images/prize.png",
	"./quick-play-close.svg": "./src/assets/images/quick-play-close.svg",
	"./red.webp": "./src/assets/images/red.webp",
	"./results.png": "./src/assets/images/results.png",
	"./schedule-white.webp": "./src/assets/images/schedule-white.webp",
	"./schedules.webp": "./src/assets/images/schedules.webp",
	"./settings.png": "./src/assets/images/settings.png",
	"./shine-bg.png": "./src/assets/images/shine-bg.png",
	"./shine-bg.webp": "./src/assets/images/shine-bg.webp",
	"./shine.png": "./src/assets/images/shine.png",
	"./single-bet-btn-active.svg": "./src/assets/images/single-bet-btn-active.svg",
	"./sparkle.webp": "./src/assets/images/sparkle.webp",
	"./stars.png": "./src/assets/images/stars.png",
	"./start_game_icon.webp": "./src/assets/images/start_game_icon.webp",
	"./statement-icon.webp": "./src/assets/images/statement-icon.webp",
	"./statement.webp": "./src/assets/images/statement.webp",
	"./sum-bet-btn-active.svg": "./src/assets/images/sum-bet-btn-active.svg",
	"./sum-bet-btn.svg": "./src/assets/images/sum-bet-btn.svg",
	"./super-draw-past.webp": "./src/assets/images/super-draw-past.webp",
	"./super-draw.webp": "./src/assets/images/super-draw.webp",
	"./sword-fight-black.webp": "./src/assets/images/sword-fight-black.webp",
	"./sword-fight-white.webp": "./src/assets/images/sword-fight-white.webp",
	"./tai-xiu-full/board-bg.svg": "./src/assets/images/tai-xiu-full/board-bg.svg",
	"./tai-xiu-full/domino-matrix-bg.svg": "./src/assets/images/tai-xiu-full/domino-matrix-bg.svg",
	"./tai-xiu-full/double-matrix-bg.svg": "./src/assets/images/tai-xiu-full/double-matrix-bg.svg",
	"./tai-xiu-full/triple-btn-bg.svg": "./src/assets/images/tai-xiu-full/triple-btn-bg.svg",
	"./tai-xiu-full/triple-face-btn-bg.svg": "./src/assets/images/tai-xiu-full/triple-face-btn-bg.svg",
	"./tai-xiu-full/video-placeholder.png": "./src/assets/images/tai-xiu-full/video-placeholder.png",
	"./ticket.png": "./src/assets/images/ticket.png",
	"./user.webp": "./src/assets/images/user.webp",
	"./video-poster.jpg": "./src/assets/images/video-poster.jpg",
	"./worldcup-bg-mobile.webp": "./src/assets/images/worldcup-bg-mobile.webp",
	"./worldcup-bg.webp": "./src/assets/images/worldcup-bg.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";